<template>
  <div>
    <!-- <pre>{{sub_repository}}</pre> -->
    <vs-row v-if="currentFolderIndex == 0">
      <vs-col
        v-for="(eachImage, index) in import_files"
        :key="index"
        vs-lg="3"
        vs-sm="6"
        vs-xs="12"
      >
        <vs-checkbox
          class="image-select-checkbox"
          v-model="files_selected"
          :vs-value="eachImage"
        >
          <!-- {{ eachImage }} -->
          <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('image')"
          >
            <img
              class="object-contain w-full"
              :src="eachImage.file_path"
              height="200"
            />
            <vs-tooltip text="Add this picture"> </vs-tooltip>
          </vs-card>

          <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('audio')"
          >
            <audio class="w-full" controls>
              <source :src="eachImage.file_path" :type="eachImage.file_type" />
              Your browser does not support the audio element.
            </audio>
          </vs-card>
          <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('video')"
          >
            <video class="w-full" controls>
              <source :src="eachImage.file_path" :type="eachImage.file_type" />
              Your browser does not support the audio element.
            </video>
          </vs-card>

          <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('application/pdf')"
          >
            {{ eachImage.file_name }}
            <span class="material-icons"> picture_as_pdf </span>
          </vs-card>

            <vs-card
            class="imageholdercontainer mb-0"
            v-if="eachImage.file_type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')"
          >
            {{ eachImage.file_name }}
            <span class="material-icons"> picture_as_pdf </span>
          </vs-card>
        </vs-checkbox>
      </vs-col>
    </vs-row>

    <!-- <pre> {{ old_repository }}</pre> -->
    <vs-button type="border" class="mb-4" @click="goBackWard()" v-if="currentFolderIndex > 0" icon="chevron_left"
      ></vs-button
    >

    <vs-card class="folder-card">
      <div
        v-for="(eachSub, index) in sub_repository"
        :key="index"
        class="folder-holder"
      >
        <vs-icon
          class="w-full p-3"
          icon-pack="feather"
          icon="icon-folder"
          @click="goForward(eachSub, sub_repository, index)"
        >
          <span class="ml-2"
            ><b>{{ eachSub.repository_name }}</b></span
          >
        </vs-icon>

        <div
          v-for="(eachImage, index) in eachSub.files"
          :key="index"
          style="width: 350px; margin: 10px;"
        >
          <vs-checkbox
            class="image-select-checkbox"
            v-model="files_selected"
            :vs-value="eachImage"
          >
            <vs-card class="imageholdercontainer mb-0">
              <img
                class="object-contain w-full"
                :src="eachImage.file_path"
                height="200"
              />
              <vs-tooltip text="Add this picture"> </vs-tooltip>
            </vs-card>
          </vs-checkbox>
        </div>
      </div>
    </vs-card>
    <vs-button
      style="position: absolute; right: 50px; bottom: 20px"
      @click="importFiles()"
      v-if="import_files.length > 0"
      >Import file</vs-button
    >
  </div>
</template>

<script>
import { repoDetails } from '@/api/file.js'

export default {
  name: 'ImportBrowserFilesModel',
  props: {
    file_repository_id: {},
    multipleSelect:{
      default:true
    },
    onlyImage:{
      default:false
    }

    
  },
  created () {
    this.fetchFile()
  },
  data () {
    return {
      currentFolderIndex: 0,
      filesInfo: [],
      import_files: [],
      sub_repository: [],
      files_selected: [],
      old_repository: [],
      sub_repository_previous: [],
      activeIndex: null
    }
  },
  watch: {
    files_selected () {
      if (Object.keys(this.files_selected).length > 1) {
        this.files_selected.shift()
      }
    }
  },
  methods: {
    goInsideFolder (sub_repository) {
      this.sub_repository = sub_repository
      
    },
    goForward (newFolderData, oldFolderData, index) {
      this.activeIndex = index
      
      this.sub_repository_previous.push(oldFolderData)
      
      this.currentFolderIndex++

      this.sub_repository = newFolderData.sub_repository
    },
    goBackWard () {
      
      
      this.currentFolderIndex--
      this.sub_repository = this.sub_repository_previous[
        this.currentFolderIndex
      ]
    },
    async fetchFile () {
      this.$vs.loading({
        text: 'Please wait while we are fetching'
      })

      try {
        const responseFiles = await repoDetails(
          this.$store.getters.customerId,
          this.file_repository_id
        )
        this.import_files = responseFiles.data.data.repository.files
        this.old_repository = responseFiles.data.data.repository.sub_repository
        this.sub_repository = [...this.old_repository]
      } catch (error) {
        this.showSuccessMessage('error', 'Something Went wrong', 'danger')
      } finally {
        this.$vs.loading.close()
      }
    },
    importFiles () {
      if (this.files_selected.length > 0) {
        if ((this.multipleSelect) || (!this.multipleSelect && this.files_selected.length === 1)) {

          const fileSelected = this.files_selected.map((ele) => {
            return ele.files_id
          })

          const fileObject = {
            file_id: fileSelected,
            fileInfo: this.files_selected
          }
          this.$emit('getImportFile', fileObject)
        } else {
          this.showSuccessMessage('error', 'Only Single Select is Allowed', 'danger')

        }
      } else {
        this.showSuccessMessage('error', 'No Files Selected', 'danger')
      }
    }
  }
}
</script>

<style>
.image-select-checkbox .vs-checkbox {
  position: absolute;
  opacity: 0;
}
.image-select-checkbox .con-slot-label {
  width: 100%;
}
.image-select-checkbox input:checked ~ .con-slot-label {
  width: 90%;
  height: 90%;
  margin: 0 auto;
}
.image-select-checkbox input:checked ~ .con-slot-label .imageholdercontainer {
  box-shadow: 0 4px 15px rgba(var(--vs-primary), 1);
}
.folder-card .vs-card--content {
  display: flex;
  flex-wrap: wrap;
}
</style>